  export const getUserWarehouse = (username) => {
    const userLocations = {
        'Adriana': 'Pomona',
        'AlbaC': 'Pomona',
        'Alexandra': 'Pomona',
        'Amberrose': 'Pomona',
        'AmberroseLW': 'Lakewood',
        'Ana': 'Pomona',
        'Andrea': 'Pomona',
        'Anyi': 'Pomona',
        'Ashley': 'Lakewood',
        'AvigailI': 'Israel',
        'Ayala': 'Israel',
        'Batya': 'Lakewood',
        'BlancaZ': 'Pomona',
        'Carmen': 'Pomona',
        'ChenW': 'Pomona',
        'China': 'Pomona',
        'Cristina': 'Pomona',
        'DahyanH': 'Pomona',
        'Dayana': 'Pomona',
        'DidiP': 'Pomona',
        'Dini': 'Pomona',
        'Dini From Home': 'Pomona',
        'DiniCare': 'Brooklyn',
        'Doris': 'Pomona',
        'DorisA': 'Pomona',
        'EitzikW': 'Pomona',
        'ElizabethJ': 'Pomona',
        'EtiLakewood': 'Lakewood',
        'EttiW': 'Lakewood',
        'Fabiola': 'Pomona',
        'Fanny': 'Pomona',
        'GabrielaM': 'Pomona',
        'Gisela': 'Pomona',
        'GittyM': 'Pomona',
        'GittyR': 'Pomona',
        'GKirsh': 'Pomona',
        'IsabelM': 'Pomona',
        'JaquelineJ': 'Pomona',
        'JennyP': 'Pomona',
        'JessicaH': 'Pomona',
        'JessicaS': 'Pomona',
        'Jessy ': 'Pomona',
        'Joanna': 'Pomona',
        'JoselynZ': 'Pomona',
        'Juliana': 'Pomona',
        'Kely': 'Pomona',
        'Liora': 'Israel',
        'Lorena': 'Pomona',
        'Lourdes ': 'Pomona',
        'LucieV': 'Pomona',
        'MalkiFriedman': 'Israel',
        'MalkiI': 'Israel',
        'MarcelaC': 'Pomona',
        'MarciaM': 'Pomona',
        'MarisolT': 'Pomona',
        'MindyLakewood': 'Lakewood',
        'MiriamM': 'Pomona',
        'MiriI': 'Israel',
        'Mishell': 'Pomona',
        'MoreliaM': 'Pomona',
        'Nava': 'Israel',
        'Nicole': 'Pomona',
        'Noga': 'Israel',
        'NubeC': 'Pomona',
        'Office': 'Pomona',
        'onsitein60': 'Pomona',
        'Paola': 'Pomona',
        'PaulZ': 'Pomona',
        'PricillaG': 'Pomona',
        'RachelG': 'Pomona',
        'RuthI': 'Israel',
        'Sandra ': 'Pomona',
        'Sari': 'Pomona',
        'SariIsrael': 'Israel',
        'SendOut': 'Pomona',
        'ShiraL': 'Pomona',
        'SorayaC': 'Pomona',
        'Svetlana': 'Lakewood',
        'TaniaM': 'Pomona',
        'TaniaT': 'Pomona',
        'TehilaPomona': 'Pomona',
        'Temp': 'Lakewood',
        'TzipiI': 'Israel',
        'Tzippy': 'Lakewood',
        'Vanessa': 'Pomona',
        'Wash&Set': 'Pomona',
        'Wendy': 'Pomona',
        'Yacira': 'Pomona',
        'Yael': 'Pomona',
        'Yafa': 'Israel',
        'YehudaW': 'Pomona',
        'Yehudit': 'Israel',
        'ZeevieK': 'Israel',
        'Zoom': 'Pomona',
        'Zoraima': 'Pomona'
    };
    return userLocations[username] || 'Pomona';
};
export const USER_WAREHOUSE = getUserWarehouse(process.env.REACT_APP_USERNAME || '');